import { StorageKey } from '../enum/StorageKey';
import { ApplicationConfig } from '../interface/response/ApplicationConfig';

export const getItemFromLocalStorage = (key: string) =>
  localStorage.getItem(key);

export const setItemToLocalStorage = (key: string, data: string) => {
  localStorage.setItem(key, data);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const removeItemFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const clearLocalStorageItems = (storageKeys: StorageKey[]) => {
  storageKeys.map((storageKey) => localStorage.removeItem(storageKey));
};

export const getConfigFromLocalStorage = (): ApplicationConfig | null => {
  const config = getItemFromLocalStorage(StorageKey.CONFIG);
  return config ? JSON.parse(config) : null;
};

export const setConfigToLocalStorage = (config: ApplicationConfig | null) => {
  if (config) {
    setItemToLocalStorage(StorageKey.CONFIG, JSON.stringify(config));
  }
};
